export default function NebulaNav({ onSignup, onLogin }) {
  return (
    <nav>
      <span className="logo">nebula</span>
      <div className="nav-btns">
        <button className="btn-nav-outline" onClick={onSignup}>Đăng ký</button>
        <button className="btn-nav" onClick={onLogin}>Đăng nhập</button>
      </div>
    </nav>
  );
}
